enum CheckoutStepType {
    Billing = 'billing',
    Customer = 'customer',
    Payment = 'payment',
    Shipping = 'shipping',
}

export default CheckoutStepType;
